/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import MainHeader from "../../../../Shared/components/Header";
import { TaxCodeTable } from "./TaxCodeTable";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const TaxCode = (props) => {
    const { createDetails, createError, exportDetails, exportLoader, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const { moduleType } = props;
    const [visible, setVisible] = useState(false);
    const [form, setForm] = useState({});
    const [view, setView] = useState(false);
    const [addMore, setAddMore] = useState(false);
    const [error, setError] = useState({});
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const handleOpen = () => {
        setVisible(true);
        setForm({}); setError({});
    };
    const handleClose = () => {
        setVisible(false);
        setForm({}); setError({});
    };

    const dispatch = useDispatch();


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Tax Code', history, moduleType ? moduleType : 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ code: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ percentage: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'taxcode',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const createTaxCode = (e) => {
        e.preventDefault();
        let emptyCode = emptyValidation('Tax Code', form?.code);
        let emptyPercentage = emptyValidation('Percentage', form?.percentage);
        setError({});
        if (emptyCode.isValid && emptyPercentage.isValid) {
            form.percentage = form.percentage ? parseFloat(form.percentage) : 0;
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: 'taxcode',
                title: 'Tax Code',
                id: form?.id,
                details: form
            });
        } else {
            setError({
                code: emptyCode?.errors || false,
                percentage: emptyPercentage.errors || false
            })
        }
    }
    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            setForm({});
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message.split("|");
            if (error[0] === 'code') {
                setError({
                    code: error[1]
                });
            }
            if (error[0] === 'percentage') {
                setError({
                    percentage: error[1]
                });
            }
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'code') {
                setError({
                    code: error[1]
                });
            }
            if (error[0] === 'percentage') {
                setError({
                    percentage: error[1]
                });
            }
        }
    }, [editDetails, editError, prevEditDetails, prevEditError]);

    const handleAddMore = (e) => {
        createTaxCode(e);
        setAddMore(true);
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'taxcode',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const onEdit = (data, view) => {
        setForm(data); setView(view); setVisible(true);
    }

    const changeHandler = (e) => {
        setForm({
            ...form, [e.target.name]: e.target.value
        })
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props}
                img={SettingsImg}
                title={moduleType ? moduleType : 'Younote Admin'} links={[{ 'label': moduleType ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Tax Code-Maintenance'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Tax Code', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                // onChange={(e) => setPassword(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Tax Code', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('TaxCode'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Tax Code', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Tax Code', 'create', moduleType ? moduleType : 'Younote Admin') &&
                                                <NavLink
                                                    to={'#'}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Tax Code</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Tax Code', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>

                            <TaxCodeTable
                                {...props}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onEdit={(data) => onEdit(data, false)}
                                view={view}
                                onView={(data) => onEdit(data, true)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${form?.id ? 'Edit' : 'Add'} Tax Code`}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createTaxCode(e)}>
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Tax Code ", <span key={"Tax Code"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    name="code"
                                    value={form?.code || ''}
                                    error={error?.code ? true : false}
                                    helperText={error?.code}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    variant={'standard'}
                                    className={clsx(classes.margin30t)}
                                    name="description"
                                    value={form?.description || ''}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Percentage ", <span key={"Percentage"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    type={'number'}
                                    className={clsx(classes.margin30t)}
                                    onWheel={(e) => e.target.blur()}
                                    name="percentage"
                                    value={form?.percentage || ''}
                                    error={error?.percentage ? true : false}
                                    helperText={error?.percentage}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })} >
                                        {form?.id ? 'Update & Close' : 'Save & Close'}
                                    </Button>
                                    {
                                        !form?.id && <Button
                                            key="add"
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}
                                            onClick={(e) => handleAddMore(e)}>
                                            Add more
                                        </Button>
                                    }
                                </Space>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'TaxCode'}
                type={'import'}
                loader={exportLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={exportDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default TaxCode